import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Register the design-system tokens from tailwind.config.ts so overrides via
// className actually win (e.g. `h-auto` over the Button variant `h-control-md`,
// `px-token-sm` over `px-control-x`). Unknown classes are never merged, which
// previously let variant classes silently defeat the override.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [
        'token-xs',
        'token-sm',
        'token-md',
        'token-lg',
        'token-xl',
        'token-2xl',
        'token-3xl',
        'control-sm',
        'control-md',
        'control-lg',
        'control-input',
        'control-x',
        'control-input-x',
        'card-padding',
        'card',
        'layout',
      ],
      borderRadius: [
        'token-none',
        'token-sm',
        'token-md',
        'token-lg',
        'token-xl',
        'token-2xl',
        'token-full',
        'token-button',
        'token-card',
        'token-input',
        'token-modal',
        'token-avatar',
        'token-badge',
        'token-tooltip',
        'token-dropdown',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
